import type from '../commons/consultationActionStatus';

const DEFAULT_STATE = {
    nextConsultationInfo: {},
    error: null,
    requestState: false,
    status: null,
    nextAdditionalTests: [],
    followUp: [],
    treatments: [],
    consultationCreated: {},
    consultationUpdated: {},
    treatmentDetails: {},
    treatmentCreated: {},
    consultationEnd: {},
    // Tracked separately from `status`, which any later request overwrites.
    consultationEndState: 'IDLE',
    physicalData: null
};

export const consultationReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let nextConsultationInfo;
    let nextAdditionalTests;
    let followUp;
    let treatments;
    let consultationCreated;
    let consultationUpdated;
    let treatmentDetails;
    let treatmentCreated;
    let consultationEnd;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    let physicalData;
    switch (actionType) {

        case type.GET_NEXT_CONSULTATION_SCHEDULE_REQUEST:
            return { ...state,nextConsultationInfo:{}, requestState, status };

        case type.GET_NEXT_CONSULTATION_SCHEDULE_SUCCESS:
            nextConsultationInfo = action.result;
            return {
                ...state,
                nextConsultationInfo,
                requestState,
                status,
            };

        case type.GET_NEXT_CONSULTATION_SCHEDULE_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_ADDITIONAL_RECOMMENDED_TEST_REQUEST:
            return { ...state,nextAdditionalTests: [], requestState, status };

        case type.GET_ADDITIONAL_RECOMMENDED_TEST_SUCCESS:
            nextAdditionalTests = action.result;
            return {
                ...state,
                nextAdditionalTests,
                requestState,
                status,
            };

        case type.GET_ADDITIONAL_RECOMMENDED_TEST_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_FOLLOW_UP_TEST_REQUEST:
            return { ...state, followUp: [], requestState, status };

        case type.GET_FOLLOW_UP_TEST_SUCCESS:
            followUp = action.result;
            return {
                ...state,
                followUp,
                requestState,
                status,
            };

        case type.GET_FOLLOW_UP_TEST_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_CONSULTATION_OBSERVATION_REQUEST:
            return { ...state,treatments: [], requestState, status };

        case type.GET_CONSULTATION_OBSERVATION_SUCCESS:
            treatments = action.result;
            return {
                ...state,
                treatments,
                requestState,
                status,
            };

        case type.GET_CONSULTATION_OBSERVATION_FAILURE:
            return { ...state, error, requestState, status };

        case type.CREATE_CONSULTATION_REQUEST:
            return { ...state, requestState, status };

        case type.CREATE_CONSULTATION_SUCCESS:
            consultationCreated = action.result;
            return {
                ...state,
                consultationCreated,
                requestState,
                status,
            };

        case type.CREATE_CONSULTATION_FAILURE:
            return { ...state, error, requestState, status };

        case type.RESET_CONSULTATION_STATE:
            return {
                ...state,
                consultationCreated: {},
            };

        case type.UPDATE_CONSULTATION_REQUEST:
            return { ...state, consultationUpdated: {}, requestState, status };

        case type.UPDATE_CONSULTATION_SUCCESS:
            consultationUpdated = action.result;
            return {
                ...state,
                consultationUpdated,
                requestState,
                status,
            };

        case type.UPDATE_CONSULTATION_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_TREATMENT_REQUEST:
            return { ...state, treatmentDetails: {}, requestState, status };

        case type.GET_TREATMENT_SUCCESS:
            treatmentDetails = action.result;
            return {
                ...state,
                treatmentDetails,
                requestState,
                status,
            };

        case type.GET_TREATMENT_FAILURE:
            return { ...state, error, requestState, status };

        case type.CREATE_UPDATE_TREATMENT_REQUEST:
            return { ...state, treatmentCreated: {}, requestState, status };

        case type.CREATE_UPDATE_TREATMENT_SUCCESS:
            treatmentCreated = action.result;
            return {
                ...state,
                treatmentCreated,
                requestState,
                status,
            };

        case type.CREATE_UPDATE_TREATMENT_FAILURE:
            return { ...state, error, requestState, status };

        case type.RESET_TREATMENT_CREATION_STATE:
            return {
                ...state,
                treatmentCreated: {},
            }

        case type.END_CONSULTATION_REQUEST:
            return { ...state, consultationEnd: {}, consultationEndState: 'PENDING', requestState, status };

        case type.END_CONSULTATION_SUCCESS:
            consultationEnd = action.result
            return {
                ...state,
                consultationEnd,
                consultationEndState: 'SUCCESS',
                requestState,
                status,
            };

        case type.END_CONSULTATION_FAILURE:
            return { ...state, error, consultationEndState: 'FAILURE', requestState, status };

        case type.UPDATE_PHYSICAL_DATA_REQUEST:
            return { ...state, physicalData: null, requestState, status };

        case type.UPDATE_PHYSICAL_DATA_SUCCESS:
            physicalData = action.result
            return {
                ...state,
                physicalData,
                requestState,
                status,
            };

        case type.UPDATE_PHYSICAL_DATA_FAILURE:
            return { ...state, error, requestState, status };

        default:
            return state;
    }
};
